<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Upload Laporan Perjalanan Dinas </strong><small>Tambah Data</small>
          </CCardHeader>
          <CCardBody>
            <CForm @submit.prevent="inputUploadlaporan">
            <CRow>
              <CCol sm="12">
                <CTextarea
                  v-model="uraian_kegiatan"
                  label="Uraian Kegiatan"
                  placeholder="Input Uraian Kegiatan"
                  readonly
                />
              </CCol>
              <CCol sm="4">
                <CInput
                  v-model="tgl_berangkat"
                  type="date"
                  label="Tanggal Pergi"
                  placeholder="Input Tanggal Pergi"
                  readonly
                />
              </CCol>
              <CCol sm="4">
                <CInput
                  v-model="tgl_pulang"
                  type="date"
                  label="Tanggal Pulang"
                  placeholder="Input Tanggal Pulang"
                  readonly
                />
              </CCol>
              <CCol sm="4">
                <CInput
                  v-model="tujuan"
                  label="Tujuan"
                  placeholder="Input Tujuan"
                  readonly
                />
              </CCol>
              <CCol sm="4">
                <CInput
                  v-model="uang_harian"
                  type="number"
                  label="Uang Harian"
                  placeholder="Input Uang Harian"
                  readonly
                />
              </CCol>
              <CCol sm="4">
                <CInput
                  v-model="uang_transport"
                  type="number"
                  label="Uang Transport"
                  placeholder="Input Uang Transport"
                  readonly
                />
              </CCol>
              <CCol sm="4">
                <CInput
                  v-model="uang_hotel"
                  type="number"
                  label="Uang Hotel"
                  placeholder="Input Uang Hotel"
                  readonly
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="6">
                <div class="form-group">
                  <label>Surat Tugas</label><br/>                  
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="onFileChange($event)" id="inputGroupFile01"
                    :placeholder="placeholder" aria-describedby="inputGroupFileAddon01">
                    <label class="custom-file-label" for="inputGroupFile01">{{placeholder}}</label>
                  </div>
                </div>  
              </CCol>
              <CCol sm="6">
                <div class="form-group">
                  <label>Surat Perjalanan Dinas & Lampirannya *dalam 1 file</label><br/>                  
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="onFileChange2($event)" id="inputGroupFile02"
                    :placeholder="placeholder2" aria-describedby="inputGroupFileAddon02">
                    <label class="custom-file-label" for="inputGroupFile02">{{placeholder2}}</label>
                  </div>
                </div>  
              </CCol>
              <CCol sm="6">
                <div class="form-group">
                  <label>Laporan Kegiatan</label><br/>                  
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="onFileChange3($event)" id="inputGroupFile03"
                    :placeholder="placeholder3" aria-describedby="inputGroupFileAddon03">
                    <label class="custom-file-label" for="inputGroupFile03">{{placeholder3}}</label>
                  </div>
                </div>  
              </CCol>
              <CCol sm="6">
                <div class="form-group">
                  <label>Dasar dalam Perjalanan Dinas (nodin/undangan)*apabila ada</label><br/>                  
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="onFileChange4($event)" id="inputGroupFile04"
                    :placeholder="placeholder4" aria-describedby="inputGroupFileAddon04">
                    <label class="custom-file-label" for="inputGroupFile04">{{placeholder4}}</label>
                  </div>
                </div>  
              </CCol>
              <CCol sm="6">
                <div class="form-group">
                  <label>Bukti Pembayaran *apabila ada</label><br/>                  
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" @change="onFileChange5($event)" id="inputGroupFile05"
                    :placeholder="placeholder5" aria-describedby="inputGroupFileAddon05">
                    <label class="custom-file-label" for="inputGroupFile05">{{placeholder5}}</label>
                  </div>
                </div>  
              </CCol>
              <CCol sm="6">
                <CInput
                  v-model="total_nominal"
                  type="number"
                  label="Total Uang eceipt"
                  placeholder="Input Total Uang"
                />
              </CCol>          
            </CRow>          
              <div class="form-actions float-right">
                <CButton type="submit" color="primary" style='margin-right:15px'>Simpan</CButton>
                <CButton color="secondary" to="/perjadin/dalamprovinsi">Batal</CButton>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Error Input"
      color="danger"
      id="modalError"
    >
      <b>Error</b>! Data gagal diinput.
    </CModal>
   
  </div>
</template>
<script>
import InputTag from 'vue-input-tag'
import axios from 'axios';
import * as Modals from '../notifications/Modals.vue'
// import { CurrencyInput } from 'vue-currency-input'

export default {
  // components: {CurrencyInput },
  name: 'Forms',
  components: { 
    InputTag ,
  },
  data () {
    return {
      uraian_kegiatan : "",
      tgl_berangkat : "",
      tgl_pulang : "",
      tujuan : "",
      id_peserta : "",
      uang_harian : 0,
      uang_transport : 0,
      uang_hotel : 0,
      total_uang : 0,
      file_surat_tugas_text : "",
      file_surat_tugas : "",
      file_perjadin_text : "",
      file_perjadin : "",
      file_laporan_kegiatan_text : "",
      file_laporan_kegiatan : "",
      file_dasar_perjadin_text : "",
      file_dasar_perjadin : "",
      file_bukti_pembayaran_text : "",
      file_bukti_pembayaran : "",
      total_nominal : 0,
      placeholder : "Pilih File",
      placeholder2 : "Pilih File",
      placeholder3 : "Pilih File",
      placeholder4 : "Pilih File",
      placeholder5 : "Pilih File",
      selected: [], // Must be an array reference!
      pesertas: [],
      show: true,
    }
  },
  mounted(){
  this.showUploadlaporan();
  this.loadData();
  },
  
  methods: {

    loadData: function(event){
      
      let username =window.btoa(this.$route.params.id_user);
      console.log(username);

      axios.get(process.env.VUE_APP_BASE_URL+"pegawais")
        .then((response) => {
              // this.pesertas=response.data;
              const datas = response.data;
              
              this.pesertas = datas.map(d=>{return d['nama_pegawai']});;
              console.log("datas::"+this.pesertas)
        });
    },

    onFileChange1(event) {
      var fileData = event.target.files[0];
      this.files_surat_tugas_text = fileData.name;
      this.files_surat_tugas = fileData;
      this.placeholder = fileData.name;
    },
    onFileChange2(event) {
      var fileData = event.target.files[0];
      this.file_perjadin_text = fileData.name;
      this.file_perjadin = fileData;
      this.placeholder = fileData.name;
    },
    onFileChange3(event) {
      var fileData = event.target.files[0];
      this.file_laporan_kegiatan_text = fileData.name;
      this.file_laporan_kegiatan = fileData;
      this.placeholder = fileData.name;
    },
    onFileChange4(event) {
      var fileData = event.target.files[0];
      this.file_dasar_perjadin_text = fileData.name;
      this.file_dasar_perjadin = fileData;
      this.placeholder = fileData.name;
    },
    onFileChange5(event) {
      var fileData = event.target.files[0];
      this.file_bukti_pembayaran_text = fileData.name;
      this.file_bukti_pembayaran = fileData;
      this.placeholder = fileData.name;
    },

    inputUploadlaporan: function(event){

      const formData = new FormData();
        
        formData.append('total_nominal', this.total_nominal)
        
        if (this.file_surat_tugas_text) {
          formData.append('file_surat_tugas', this.file_surat_tugas, this.file_surat_tugas.name) 
          formData.append('file_surat_tugas_text', this.file_surat_tugas.name)
        }
        if (this.file_perjadin_text) {
          formData.append('file_perjadin', this.file_perjadin, this.file_perjadin.name) 
          formData.append('file_perjadin_text', this.file_perjadin.name)
        }
        if (this.file_dasar_perjadin_text) {
          formData.append('file_dasar_perjadin', this.file_dasar_perjadin, this.file_dasar_perjadin.name) 
          formData.append('file_dasar_perjadin_text', this.file_dasar_perjadin.name)
        }
        if (this.file_bukti_pembayaran_text) {
          formData.append('file_bukti_pembayaran', this.file_bukti_pembayaran, this.file_bukti_pembayaran.name) 
          formData.append('file_bukti_pembayaran_text', this.file_bukti_pembayaran.name)
        }
        if (this.file_laporan_kegiatan_text) {
          formData.append('file_laporan_kegiatan', this.file_laporan_kegiatan, this.file_laporan_kegiatan.name) 
          formData.append('file_laporan_kegiatan_text', this.file_laporan_kegiatan.name)
        }
      
      // alert(JSON.stringify(anggota));
      axios.post(process.env.VUE_APP_BASE_URL+"perjadin", formData)
        .then((response) => {
            // console.log(response);
            // alert(response.data);
            if(response.status==200){
              this.$router.push('/perjadin/dalamprovinsi');
            }
            else{
              this.modalError = true;
            }            
        })
    },
    showUploadlaporan: function(event){
    
    const dalamprovinsi = { 
                        uraian_kegiatan: this.uraian_kegiatan, 
                        tgl_berangkat: this.tgl_berangkat,
                        tgl_pulang: this.tgl_pulang,
                        tujuan: this.tujuan,
                        id_peserta: this.id_peserta,
                        uang_harian: this.uang_harian,
                        uang_transport: this.uang_transport,
                        uang_hotel: this.uang_hotel,
                        total_uang: this.total_uang
                        };
    // alert(JSON.stringify(pekerjaan));
    // alert(this.$route.params.id_User);

    let username =window.btoa(this.$route.params.id_user);
    console.log(username);

    axios.get(process.env.VUE_APP_BASE_URL+"perjadin/"+this.$route.params.id_perjadin)
      .then((response) => {            
            this.uraian_kegiatan=response.data.uraian_kegiatan;
            this.tgl_berangkat=response.data.tgl_berangkat;
            this.tgl_pulang=response.data.tgl_pulang;
            this.tujuan=response.data.tujuan;
            this.id_peserta=response.data.id_peserta;
            this.uang_harian=response.data.uang_harian;
            this.uang_transport=response.data.uang_transport;
            this.uang_hotel=response.data.uang_hotel;
            this.total_uang=response.data.total_uang;
      })
  }
  }
}
</script>